
import 'babel-polyfill'
import Vue from 'vue'

import App from '@/App'
import router from '@/router'
import store from '@/store'
import VeeValidate, { Validator } from 'vee-validate'
import VTooltip from 'v-tooltip'
import '@/utils/interceptors.js'
import '@/utils/global.js'
import '@/utils/filters.js'
import '@/utils/acl.js'

import fr from 'vee-validate/dist/locale/fr'

Vue.use(VeeValidate, {
  inject: false,
  locale: 'fr',
  dictionary: {
    fr: { messages: fr.messages }
  }
})

Vue.use(VTooltip)

const dict = {
  custom: {
    somme_surface_ilot: {
      confirmed: 'La somme des surfaces des sols est différente de la SAU'
    },
    somme_par_scenario: {
      confirmed: 'Somme surface incohérente'
    },
    exploitant_email: {
      required: 'Le champ "email" est obligatoire si vous souhaitez associer à l\'exploitant'
    },
    exploitant_prenom: {
      required: 'Le champ "prénom" est obligatoire si vous souhaitez associer à l\'exploitant'
    },
    exploitant_nom: {
      required: 'Le champ "nom" est obligatoire si vous souhaitez associer à l\'exploitant'
    },
    date_semis: {
      date_between: 'Le champ "date_semis" est doit être renseigné entre le 01/08 inclus et le 30/09 inclus'
    }
  }
}

Validator.localize('fr', dict)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
